//新主题列表

export const entityList = [
    {
        id: 1,
        name: "youzu",
        url: "aiservice.youzu.com",
        service: "service.youzu.com",
        qaService: "qaservice.youzu.com",
        ai: true
    },
    {
        id: 2,
        name: "dushang",
        url: "aiservice.dushang.top",
        service: "service.dushang.top",
        qaService: "qa-service.dushang.top",
        ai: false
    },
    {
        id: 3,
        name: "aimuyi",
        url: "aiservice.aimuyi.top",
        service: "service.aimuyi.top",
        qaService: "qa-service.aimuyi.top",
        ai: false
    },
    {
        id: 5,
        name: "youzuos",
        url: "aiservice.youzuos.com",
        service: "service.youzuos.com",
        qaService: "qaservice.youzuos.com",
        ai: true
    },
    {
        id: 4,
        name: "shqizhuo",
        url: "aiservice.shqizhuo.cn",
        service: "service.shqizhuo.cn",
        qaService: "qaservice.shqizhuo.cn",
        ai: false
    },
]

export function islocation(entity) {
    if (entity) {
        return window.location.host.indexOf(entity) > -1
    } else {
        return false
    }
};

export function isEntity(entity) {
    if (entity) {
        return window.location.host.split(".")[1] === entity
    } else {
        return false
    }
};

export const entityIndex = entityList.findIndex(item => { return isEntity(item.name) })

export const entity = entityIndex > -1 ? entityList[entityIndex] : entityList[0]